module.exports = __webpack_public_path__ + "img/solution@2x.eeb454d2.png";